export class EventEmitter {
    constructor(host, eventName) {
        this.host = host;
        this.eventName = eventName;
    }
    emit(payload, customEventInit = {}) {
        return this.host.dispatchEvent(new CustomEvent(this.eventName, {
            detail: payload,
            ...customEventInit,
        }));
    }
}
export function Output() {
    return function (prototype, propertyName) {
        const emitterKey = Symbol();
        Object.defineProperty(prototype, propertyName, {
            get: function () {
                return (this[emitterKey] || (this[emitterKey] = new EventEmitter(this, propertyName)));
            },
        });
    };
}
//# sourceMappingURL=event.js.map